import type { FC } from 'react';
import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import {
  AppSection,
  TopicsSection,
  UpdatesSection,
  RankingSection,
  CarouselSection,
  ContactSection,
} from '@/pages/home/components/SectionsTop';
import {
  CardsSection,
  AboutSection,
  FaqSection,
  IndexSection,
  FeaturesSection,
  MediaSection,
  CommentsSection,
} from '@/pages/home/components/SectionsBottom';
import Footer from '@/pages/home/components/Footer';

const Home: FC = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <AboutSection />
        <FaqSection />
        <IndexSection />
        <FeaturesSection />
        <MediaSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
};

export default Home;